exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1-F0C7VbAOM8e-iyszbyUZ{position:absolute;width:100%;height:100%;top:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}html[dir] ._1-F0C7VbAOM8e-iyszbyUZ{border:0}html[dir=ltr] ._1-F0C7VbAOM8e-iyszbyUZ{left:0}html[dir=rtl] ._1-F0C7VbAOM8e-iyszbyUZ{right:0}._3P8aODo_36hbUxLiaW___6{font-size:12px;font-weight:400;color:\"[theme:neutralSecondary, default:#666666]\"}html[dir] ._3P8aODo_36hbUxLiaW___6{padding-top:20px}", ""]);

// exports
exports.locals = {
	"messageContainer": "_1-F0C7VbAOM8e-iyszbyUZ",
	"messageText": "_3P8aODo_36hbUxLiaW___6"
};